const api_url = 'https://48gfivc83f.execute-api.us-east-1.amazonaws.com/api/api';
const ads_url_test = 'https://t410mo172c.execute-api.us-east-1.amazonaws.com/dev-ads-test/api';
const file_url = 'https://48gfivc83f.execute-api.us-east-1.amazonaws.com/api/api';
const commentLimit = 300;
const max_file_size = 10 * 1000 * 1000;
const GA_TRACKING_ID = 'G-J5CP5MSP3R';

export { api_url, commentLimit, file_url, max_file_size, GA_TRACKING_ID, ads_url_test };
